document.addEventListener('DOMContentLoaded', function () {

  const totalAllowedEl = document.querySelector('.js-mix-total');
  const wellblendCountEl = document.querySelector('.js-wellblend-count');

  if (!totalAllowedEl) return;

  // ==================== ORIGINAL 20-CAN LOGIC (100% unchanged) ====================
  const totalAllowed = parseInt(totalAllowedEl.value) || 20;
  const canInputs = document.querySelectorAll('.js-mix-input');
  const inputBtns = document.querySelectorAll('.js-mix-input-btn');
  const inputPlusBtns = document.querySelectorAll('.js-mix-input-btn--plus');
  const addToCartBtn = document.querySelector('button[name="add"]');
  const productQuantity = document.querySelector('.product-form__quantity');

  const counter = document.querySelector('.js-mix-counter');
  const counterMsg = document.querySelector('.js-mix-counter-msg');
  const emojiNormal = document.querySelector('.js-mix-emoji-normal');
  const emojiHappy = document.querySelector('.js-mix-emoji-happy');
  const emojiParty = document.querySelector('.js-mix-emoji-party');

  let currentTotal = 0;

  if (productQuantity) productQuantity.style.display = 'none';

  function countCanSelections() {
    currentTotal = 0;
    canInputs.forEach(input => currentTotal += parseInt(input.value, 10) || 0);
  }

  function getWellblendTotal() {
    return Array.from(document.querySelectorAll('.js-wellblend-input'))
      .reduce((sum, input) => sum + (parseInt(input.value) || 0), 0);
  }

  function clampGroup(inputs, max, isCanGroup) {
    let total = isCanGroup ? currentTotal : getWellblendTotal();
    while (total > max) {
      let highestInput = null;
      let highestValue = 0;
      inputs.forEach(input => {
        const val = parseInt(input.value) || 0;
        if (val > highestValue) {
          highestValue = val;
          highestInput = input;
        }
      });
      if (highestInput && highestValue > 0) {
        highestInput.value = highestValue - 1;
        total--;
      } else break;
    }
    inputs.forEach(input => { if (parseInt(input.value) < 0) input.value = 0; });
  }

  function updateCounter() {
    countCanSelections();
    const wbTotal = getWellblendTotal();
    const overallTotal = totalAllowed + (parseInt(wellblendCountEl ? wellblendCountEl.value : 0) || 0);
    const displayTotal = currentTotal + wbTotal;

    counterMsg.textContent = (displayTotal < 10 && overallTotal > 10 ? '0' + displayTotal : displayTotal) + '/' + overallTotal;

    if (displayTotal === 0) {
      counter.classList.remove('fade-in', 'success');
      emojiNormal.classList.remove('fade-out');
      emojiParty.classList.add('fade-out');
      emojiHappy.classList.add('fade-out');
      inputPlusBtns.forEach(button => button.disabled = false);
    } else if (displayTotal >= overallTotal - 3 && displayTotal < overallTotal) {
      counter.classList.add('fade-in');
      counter.classList.remove('success');
      emojiNormal.classList.add('fade-out');
      emojiParty.classList.add('fade-out');
      emojiHappy.classList.remove('fade-out');
      inputPlusBtns.forEach(button => button.disabled = false);
    } else if (displayTotal === overallTotal) {
      counter.classList.add('fade-in', 'success');
      emojiNormal.classList.add('fade-out');
      emojiHappy.classList.add('fade-out');
      emojiParty.classList.remove('fade-out');
      inputPlusBtns.forEach(button => button.disabled = true);
    } else {
      counter.classList.add('fade-in');
      counter.classList.remove('success');
      emojiHappy.classList.add('fade-out');
      emojiParty.classList.add('fade-out');
      emojiNormal.classList.remove('fade-out');
      inputPlusBtns.forEach(button => button.disabled = false);
    }
  }

  // Can listeners (works for ALL products)
  canInputs.forEach(input => input.addEventListener('input', updateCounter));
  inputBtns.forEach(btn => btn.addEventListener('click', updateCounter));

  // ==================== HYBRID BUNDLE LIMITS (cans + WellBlend) ====================
  const wellblendInputs = document.querySelectorAll('.js-wellblend-input');
  if (wellblendInputs.length > 0 && wellblendCountEl) {
    const maxCans = totalAllowed;           // 12 or 16
    const maxWellblend = parseInt(wellblendCountEl.value) || 2;

    const enforceLimits = function () {
      // Clamp cans
      countCanSelections();
      clampGroup(canInputs, maxCans, true);

      // Clamp WellBlends
      clampGroup(wellblendInputs, maxWellblend, false);

      updateCounter();
    };

    // Trigger on typing AND on + / – buttons for BOTH groups
    canInputs.forEach(input => input.addEventListener('input', enforceLimits));
    wellblendInputs.forEach(input => input.addEventListener('input', enforceLimits));
    inputBtns.forEach(btn => btn.addEventListener('click', enforceLimits));
  }

  // Add-to-cart validation
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (event) {
      countCanSelections();
      const wbTotal = getWellblendTotal();
      const overallTotal = totalAllowed + (parseInt(wellblendCountEl ? wellblendCountEl.value : 0) || 0);
      const actualTotal = currentTotal + wbTotal;

      if (actualTotal !== overallTotal) {
        event.preventDefault();
        alert(`Please select exactly ${overallTotal} items in total (${totalAllowed} cans + ${wellblendCountEl ? wellblendCountEl.value : 0} WellBlend).`);
      } else {
        canInputs.forEach(input => { if (input.value == 0) input.disabled = true; });
        wellblendInputs.forEach(input => { if (input.value == 0) input.disabled = true; });
      }
    });
  }

  // Initial load
  updateCounter();
});